import React from "react";
import ReactDOM from "react-dom/client";
import "../src/fonts/index.scss";
import App from "./App";
import "./styles/global.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
